import React from "react";

const CategoriesForSeller = ({ index, heading, products }) => {
  return (
    <div id={index}>
      <h1 className="text-xs font-semibold text-gray-800">{heading}</h1>
      <div>
        {products.map((curElem, index) => {
          return (
            <div className="flex items-center my-2" key={index}>
              <input id={curElem} type="checkbox" className="block" />
              <label for={curElem} className="ml-2 text-gray-800 block text-xs">
                {curElem}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CategoriesForSeller;
